import { render } from "./ReviewCreate.vue?vue&type=template&id=4c28bfa8&ts=true"
import script from "./ReviewCreate.vue?vue&type=script&lang=ts"
export * from "./ReviewCreate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__